// extracted by mini-css-extract-plugin
export var cmlIcon = "styles-module--cmlIcon--aa102";
export var datachainIcon = "styles-module--datachainIcon--2edcb";
export var dvcIcon = "styles-module--dvcIcon--f1f1d";
export var other = "styles-module--other--41302";
export var studioIcon = "styles-module--studioIcon--3e2d6";
export var vscodeIcon = "styles-module--vscodeIcon--a985b";